import { matchPath } from 'react-router-dom';

// Appearance metadata only. Route access remains in App and its layouts.
// Specific paths precede parameterized paths so actions such as `new` and
// `service-visit` receive form styling rather than detail styling.
const routeGroups = [
  ['orders', 'list', ['/orders']],
  ['orders', 'list', ['/orders/holiday-catering']],
  ['orders', 'detail', ['/orders/:id']],
  ['purchasing', 'form', ['/purchase_orders/new', '/purchase_orders/:id/invoice_create']],
  ['purchasing', 'list', ['/purchase_orders']],
  ['purchasing', 'detail', ['/purchase_orders/:id/invoice', '/purchase_orders/:id', '/purchase_orders_by_price/:id']],
  ['receiving', 'list', ['/pending_inventory', '/invoice', '/credit_note']],
  ['receiving', 'form', ['/invoice/new', '/credit_note/new']],
  ['receiving', 'labels', ['/invoice/:id/labels']],
  ['receiving', 'detail', ['/pending_inventory/:id', '/invoice/:id', '/credit_note/:id']],
  ['pricing', 'settings', ['/price_lists/correction-rules']],
  ['pricing', 'report', ['/compare_price_lists', '/price_lists/:id/errors']],
  ['pricing', 'list', ['/price_lists']],
  ['pricing', 'detail', ['/price_lists/:id']],
  ['production', 'list', ['/session'], 'sessions-list-page'],
  ['production', 'form', ['/session/new'], 'session-create-page'],
  ['production', 'form', ['/session/:id/edit', '/session/:id/edit_finished']],
  ['production', 'labels', ['/session/:id/intermediate_labels', '/session/:id/labels']],
  ['production', 'detail', ['/session/:id']],
  ['shipping', 'list', ['/shipment']],
  ['shipping', 'form', ['/shipment/new', '/shipment/:id/edit']],
  ['shipping', 'detail', ['/shipment/:id']],
  ['returns', 'list', ['/return']],
  ['returns', 'form', ['/return/new', '/return/:id/add_inventory']],
  ['returns', 'detail', ['/return/:id']],
  ['market-inventory', 'scanner', ['/market-inventory/scanner']],
  ['market-inventory', 'dashboard', ['/market-inventory/stock-levels']],
  ['market-inventory', 'list', ['/market-inventory/alerts']],
  ['market-inventory', 'report', ['/market-inventory/consumption']],
  ['maintenance', 'dashboard', ['/maintenance', '/maintenance/tasks']],
  ['maintenance', 'settings', ['/maintenance/settings', '/maintenance/service-providers']],
  ['maintenance', 'form', [
    '/maintenance/machines/new', '/maintenance/machines/:id/edit',
    '/maintenance/facilities/new', '/maintenance/facilities/:id/edit',
    '/maintenance/task-templates/new', '/maintenance/task-templates/:id/edit', '/maintenance/task-templates/:id',
    '/maintenance/task-assignments/new', '/maintenance/task-assignments/:id/edit',
    '/maintenance/records/new', '/maintenance/records/service-visit', '/maintenance/records/:id/edit',
  ]],
  ['maintenance', 'list', [
    '/maintenance/machines', '/maintenance/facilities', '/maintenance/task-templates',
    '/maintenance/task-assignments', '/maintenance/records',
  ]],
  ['maintenance', 'detail', ['/maintenance/machines/:id', '/maintenance/facilities/:id', '/maintenance/records/:id']],
  ['inventory', 'list', ['/reports/inventory'], 'inventory-list-page'],
  ['reports', 'report', [
    '/reports/inventory_items', '/reports/shipment', '/reports/recall', '/reports/invoices',
    '/reports/production', '/reports/waste', '/reports/yield', '/reports/expired_inventories',
    '/reports/ingredients', '/reports/weighted_price', '/reports/receiving', '/reports/R365',
  ]],
  ['inventory-audit', 'list', ['/inventory/audit']],
  ['inventory-audit', 'form', ['/inventory/audit/:id/edit']],
  ['inventory-audit', 'detail', ['/inventory/audit/:id']],
  ['inventory', 'form', ['/inventory/locations']],
  ['inventory', 'detail', ['/inventory/:id'], 'inventory-detail-page'],
  ['provider', 'dashboard', ['/provider-portal']],
  ['provider', 'list', ['/provider-portal/tasks']],
  ['provider', 'detail', ['/provider-portal/tasks/:id']],
];

export const getRefinedUIRouteContext = (pathname, { refinedProductionUI = true } = {}) => {
  const route = routeGroups.find(([, , paths]) => paths.some((path) => matchPath({ path, end: true }, pathname)));
  const [family, kind, , pageClass = ''] = route || ['general', 'page', []];
  const isSpecialized = !!pageClass || (refinedProductionUI && !!matchPath({ path: '/session/:id/edit', end: true }, pathname));

  return {
    family,
    kind,
    pageClass,
    isSpecialized,
    className: ['refined-page', `refined-page--${kind}`, `refined-section--${family}`, pageClass, !isSpecialized && 'site-refined-page'].filter(Boolean).join(' '),
  };
};
